import type { IResultData } from '@quesmed/types/models';
import { GiPartyPopper } from 'react-icons/gi';
import { LuDownload } from 'react-icons/lu';
import { Snippet } from '@/core/ui';
import { fileDownload } from '@/utils';

type FeedbackProps = { response: Partial<IResultData>; message?: string };

export const SuccessDataFeedback = ({ message, response }: FeedbackProps) => {
  const file = `DATA_${Date.now().toString().slice(0, 7)}.json`;

  const handleDataDownload = () => {
    fileDownload(file, JSON.parse(response.data || 'null'));
  };
  return (
    <div className='w-full px-8 flex flex-col space-y-6 justify-center items-center'>
      <Snippet
        tooltipProps={{
          content: 'Click to download',
          placement: 'right',
        }}
        onCopy={handleDataDownload}
        copyIcon={<LuDownload className='w-5 h-5' />}
        checkIcon={<LuDownload className='w-5 h-5' />}
        size='md'
        color='success'
        symbol='File:'
      >
        {file}
      </Snippet>
      <div className='flex space-x-2 items-center'>
        <GiPartyPopper className='text-warning-600 w-8 h-8' />
        <span>{message || 'Yay! Process Completed Successfully!'}</span>
      </div>
    </div>
  );
};
